import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import { getArticle, articles } from "@/mocks/article";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/pages/home/components/Footer";

const siteUrl = typeof import.meta !== 'undefined' && (import.meta as any).env?.VITE_SITE_URL
  ? (import.meta as any).env.VITE_SITE_URL
  : "https://cssbuy.gay";

const articleHeroImages: Record<string, string> = {
  "guia-completo-cssbuy-spreadsheet": "https://readdy.ai/api/search-image?query=A%20bright%20modern%20home%20office%20desk%20with%20a%20laptop%20displaying%20a%20colorful%20product%20spreadsheet%20next%20to%20neatly%20arranged%20white%20sneakers%20and%20a%20beige%20hoodie%2C%20warm%20golden%20hour%20sunlight%20streaming%20through%20a%20window%20creating%20soft%20shadows%2C%20wooden%20desk%20surface%2C%20potted%20monstera%20plant%2C%20cozy%20productive%20atmosphere%2C%20editorial%20photography&width=1200&height=600&seq=art-hero-guide-v2&orientation=landscape",
  "cssbuy-e-seguro": "https://readdy.ai/api/search-image?query=A%20golden%20padlock%20on%20a%20dark%20slate%20surface%20with%20soft%20amber%20security%20lighting%2C%20a%20blurred%20cardboard%20package%20in%20background%2C%20dramatic%20yet%20elegant%20product%20photography%20conveying%20online%20shopping%20trust%20and%20safety%2C%20premium%20professional%20look&width=1200&height=600&seq=art-hero-safe-v2&orientation=landscape",
  "cssbuy-vs-sugargoo": "https://readdy.ai/api/search-image?query=Two%20boxing%20gloves%20one%20emerald%20green%20and%20one%20navy%20blue%20facing%20each%20other%20on%20a%20clean%20concrete%20surface%2C%20dramatic%20side%20lighting%20casting%20long%20shadows%2C%20high%20contrast%20professional%20sports%20comparison%20photography&width=1200&height=600&seq=art-hero-vs-v2&orientation=landscape",
  "melhores-marcas-cssbuy": "https://readdy.ai/api/search-image?query=A%20vibrant%20flatlay%20of%20fashion%20brand%20logo%20tags%20scattered%20on%20a%20warm%20terracotta%20surface%2C%20top-down%20view%20with%20rich%20saturated%20colors%2C%20creative%20editorial%20composition%2C%20brand%20identity%20and%20lifestyle%20concept%20photography&width=1200&height=600&seq=art-hero-brands-v2&orientation=landscape",
  "como-fazer-qc-cssbuy": "https://readdy.ai/api/search-image?query=A%20photographers%20desk%20with%20DSLR%20camera%20pointing%20at%20sneakers%20on%20white%20sweep%2C%20studio%20lighting%20setup%20with%20monitor%20showing%20detailed%20photos%2C%20warm%20professional%20product%20photography%20studio%20atmosphere&width=1200&height=600&seq=art-hero-qc-v2&orientation=landscape",
  "envio-cssbuy-brasil": "https://readdy.ai/api/search-image?query=Multiple%20shipping%20boxes%20stacked%20against%20a%20bright%20yellow%20wall%20with%20subtle%20Brazilian%20color%20accents%2C%20a%20shipping%20label%20with%20tracking%20barcode%20in%20foreground%2C%20warm%20tropical%20sunlight%2C%20vibrant%20logistical%20warehouse%20photography&width=1200&height=600&seq=art-hero-brasil-v2&orientation=landscape",
  "envio-cssbuy-portugal": "https://readdy.ai/api/search-image?query=Lisbon%20style%20cobblestone%20street%20with%20pastel%20colored%20buildings%20and%20a%20modern%20delivery%20box%20in%20foreground%2C%20soft%20Mediterranean%20golden%20hour%20light%2C%20warm%20terracotta%20and%20azure%20tones%2C%20travel%20lifestyle%20commerce%20photography&width=1200&height=600&seq=art-hero-portugal-v2&orientation=landscape",
  "top-produtos-cssbuy": "https://readdy.ai/api/search-image?query=Circular%20arrangement%20of%20fashion%20items%20colorful%20sneakers%20cap%20and%20sunglasses%20on%20warm%20peach%20background%20with%20golden%20trophy%20center%2C%20top-down%20celebratory%20editorial%20flatlay%20photography%20with%20rich%20premium%20colors&width=1200&height=600&seq=art-hero-top-v2&orientation=landscape",
  "cssbuy-yupoo-guia": "https://readdy.ai/api/search-image?query=Modern%20tablet%20displaying%20photo%20album%20gallery%20next%20to%20smartphone%20with%20shopping%20cart%2C%20on%20warm%20wooden%20desk%20with%20coffee%20cup%2C%20soft%20morning%20window%20light%2C%20cozy%20productive%20tech%20lifestyle%20photography&width=1200&height=600&seq=art-hero-yupoo-v2&orientation=landscape",
  "planilha-cssbuy-atualizada": "https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20printed%20spreadsheet%20colorful%20sticky%20notes%20and%20green%20highlighter%2C%20tablet%20showing%20charts%2C%20bright%20natural%20daylight%2C%20modern%20orderly%20productive%20workspace%20photography%20with%20fresh%20aesthetic&width=1200&height=600&seq=art-hero-planilha-v2&orientation=landscape",
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  const article = slug ? getArticle(slug) : null;

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="pt-20 min-h-screen flex items-center justify-center">
          <div className="text-center px-4">
            <h1 className="font-heading text-2xl font-bold text-foreground-950 mb-3">Artigo não encontrado</h1>
            <p className="text-sm text-foreground-500 mb-6">O artigo que você procura não existe ou foi removido.</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-line"></i>
              Voltar ao início
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="pt-16">
        {/* Breadcrumb */}
        <div className="px-4 md:px-8 lg:px-14 py-4 bg-background-50 border-b border-background-200">
          <div className="max-w-[900px] mx-auto">
            <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500 flex-wrap">
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                Home
              </Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
                Blog
              </Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">
                {article.title.length > 50 ? article.title.slice(0, 50) + "..." : article.title}
              </span>
            </nav>
          </div>
        </div>

        {/* Article Header */}
        <article className="px-4 md:px-8 lg:px-14 py-10 md:py-14 bg-background-50">
          <div className="max-w-[900px] mx-auto">
            <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider bg-primary-50 px-3 py-1 rounded-full mb-4">
              Guia CSSBuy
            </span>
            <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-4">
              {article.title}
            </h1>
            <div className="flex items-center gap-4 text-xs md:text-sm text-foreground-500 mb-8 flex-wrap">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i>
                {article.author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i>
                {article.datePublished}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {article.sections.length + 2} min de leitura
              </span>
            </div>

            {/* Featured Image */}
            <div className="rounded-2xl md:rounded-3xl overflow-hidden h-56 md:h-72 lg:h-80 mb-10">
              <img
                src={articleHeroImages[article.slug] || articleHeroImages["guia-completo-cssbuy-spreadsheet"]}
                alt={article.title}
                title={article.title}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Article Content */}
            <div className="max-w-none">
              {article.sections.map((section, idx) => (
                <section key={idx} className="mb-10">
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                    {section.heading}
                  </h2>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {section.content}
                  </p>
                </section>
              ))}

              {/* Conclusion */}
              <section className="bg-primary-50/50 rounded-2xl p-6 md:p-8 mb-10 border border-primary-100">
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">
                  Conclusão
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
                  {article.conclusion}
                </p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors cursor-pointer whitespace-nowrap"
                >
                  Acessar CSSBuy Sheet Agora
                  <i className="ri-arrow-right-up-line"></i>
                </a>
              </section>
            </div>

            {/* Internal Links */}
            <div className="border-t border-background-200 pt-8 mt-8">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar para a página inicial
              </Link>
            </div>
          </div>
        </article>

        {/* Related Articles */}
        <section className="px-4 md:px-8 lg:px-14 py-12 bg-background-100/70">
          <div className="max-w-[900px] mx-auto">
            <h3 className="font-heading text-lg font-bold text-foreground-950 mb-6">
              Artigos Relacionados
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
              {Object.values(articles)
                .filter((a) => a.slug !== article.slug)
                .slice(0, 6)
                .map((related) => (
                  <Link
                    key={related.slug}
                    to={`/artigo/${related.slug}`}
                    className="flex items-start gap-2 px-4 py-3 bg-background-50 rounded-xl text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer border border-background-200 group"
                  >
                    <i className="ri-file-text-line mt-0.5 flex-shrink-0 group-hover:text-primary-500"></i>
                    <span className="line-clamp-2 leading-snug">{related.title}</span>
                  </Link>
                ))}
            </div>
          </div>
        </section>

        {/* Schema.org */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": `${siteUrl}/` },
                { "@type": "ListItem", "position": 2, "name": "Artigos", "item": `${siteUrl}/` },
                { "@type": "ListItem", "position": 3, "name": article.title, "item": `${siteUrl}/artigo/${article.slug}` }
              ]
            }),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Article",
              "headline": article.title,
              "description": article.metaDescription,
              "image": articleHeroImages[article.slug] || articleHeroImages["guia-completo-cssbuy-spreadsheet"],
              "datePublished": article.datePublished,
              "dateModified": article.dateModified,
              "author": { "@type": "Organization", "name": article.author, "url": siteUrl },
              "publisher": {
                "@type": "Organization",
                "name": "CSSBuy.gay",
                "url": siteUrl,
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png"
                }
              },
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": `${siteUrl}/artigo/${article.slug}`
              }
            }),
          }}
        />
      </main>
      <Footer />
    </>
  );
}